module.exports = __webpack_public_path__ + "img/aiIcon-faceCompare.0a4cdb7d.svg";